import React from 'react';
import {Icon, Text} from '@cloudaper/react';

const AppStepper = props => {
  const {currentStep, handleStep} = props;

  return (
    <div
      className={`appStepper${currentStep === 1 ? ' appStepperOffset' : ''}`}
    >
      <Text className="appStepperItem">
        <div className="appStepperText">Ověřit e-mail</div>

        {currentStep >= 2 ? (
          <Icon name="check-circle-filled" />
        ) : (
          <span className="appStepperCircle">1</span>
        )}
      </Text>

      <Text className="appStepperItem">
        <div className="appStepperText">Založit účet</div>

        {currentStep >= 3 ? (
          <Icon name="check-circle-filled" />
        ) : (
          <span className="appStepperCircle">2</span>
        )}
      </Text>

      <Text
        className={`appStepperItem${currentStep >= 4 ? ' appStepperLink' : ''}`}
        onClick={currentStep >= 4 ? () => handleStep(3) : undefined}
      >
        <div className="appStepperText">Nastavit oběh</div>

        {currentStep >= 4 ? (
          <Icon name="check-circle-filled" />
        ) : (
          <span className="appStepperCircle">3</span>
        )}
      </Text>
    </div>
  );
};

export default AppStepper;
